// These keys are used to map the index aliases to the actual index name coming
// from the backend
// see: app/serializers/learn/dashboard_serializer.rb → as_json

export const TAGS = 'tags';
export const SECTIONS_ELEMENTS = 'sectionsElements';
export const LESSONS_PATHS = 'lessonsPaths';
